/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Constants for SettingsLabels component
 *
 * @author Aleksandr Perkhunov
 * @version 1.3.0
 * @since 1.3.0
 */

export const GET_SETTINGS_LABELS_LIST_ACTION = '@@b2b_portal_ui/settingsLabels/GET_SETTINGS_LABELS_LIST_ACTION';
export const GET_SETTINGS_LABELS_LIST_SUCCESS = '@@b2b_portal_ui/settingsLabels/GET_SETTINGS_LABELS_LIST_SUCCESS';
export const GET_SETTINGS_LABELS_LIST_FAILURE = '@@b2b_portal_ui/settingsLabels/GET_SETTINGS_LABELS_LIST_FAILURE';

export const ADD_SETTINGS_LABEL_ACTION = '@@b2b_portal_ui/settingsLabels/ADD_SETTINGS_LABEL_ACTION';
export const ADD_SETTINGS_LABEL_SUCCESS = '@@b2b_portal_ui/settingsLabels/ADD_SETTINGS_LABEL_SUCCESS';
export const ADD_SETTINGS_LABEL_FAILURE = '@@b2b_portal_ui/settingsLabels/ADD_SETTINGS_LABEL_FAILURE';

export const REMOVE_SETTINGS_LABEL_ACTION = '@@b2b_portal_ui/settingsLabels/REMOVE_SETTINGS_LABEL_ACTION';
export const REMOVE_SETTINGS_LABEL_SUCCESS = '@@b2b_portal_ui/settingsLabels/REMOVE_SETTINGS_LABEL_SUCCESS';
export const REMOVE_SETTINGS_LABEL_FAILURE = '@@b2b_portal_ui/settingsLabels/REMOVE_SETTINGS_LABEL_FAILURE';
